import { getAvailableIntegrationsQueryOptions } from "@/queries/integrations";
import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/integrations/$integration/connect",
)({
  validateSearch: (search) =>
    z
      .object({
        mode: z.enum(["setup", "update"]),
      })
      .parse(search),
  async beforeLoad({ params, context, search }) {
    const { integration } = params;
    if (!integration) {
      throw new Error("Integration parameter is required");
    }
    await context.queryClient.ensureQueryData(
      getAvailableIntegrationsQueryOptions(),
    );

    // Redirect to first step
    throw redirect({
      to: "/settings/integrations/$integration/$mode",
      params: { integration, mode: search.mode },
    });
  },
});
